module.exports = __webpack_public_path__ + "static/media/David-Kreda-sepia-cropped-small.b6ead8c7.png";